import React, { Component } from "react";
import Headers from "../Layouts/Headers";
import axios from "axios";
import $ from "jquery";
import { MDBTableEditable } from "../_mdbcomponents/components/pro/TableEditable/TableEditable";
import { MDBCard } from "../_mdbcomponents/components/Card/Card";
import { MDBCardHeader } from "../_mdbcomponents/components/Card/CardHeader/CardHeader";
import { MDBCardBody } from "../_mdbcomponents/components/Card/CardBody/CardBody";
import { TriageSidebar } from "../Layouts/TriageSidebar";
import { Preview, print } from "react-html2pdf";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import TheatreSidebar from "../Layouts/TheatreSidebar";

export class PostOpObservationScare1 extends Component {
  constructor(props) {
    super(props);

   

    const url = "";
    this.state = {
      ObservationsCare1Time: "",
      Airway: "",
      oxygen: "",
      Resp: "",
      Pulse: "",
      Temp: "",
      BP: "",
      SPO2: "",
      LOC: "",
      Headlift: "",
      LimbObs: "",
      myParentTrigger: "",
      patientName: localStorage.getItem("currentVisitName"),
      Datetime:"",
      tablevaluesglobal: {},
      loading: false
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.modal = true;
    this.PrintWindow = this.PrintWindow.bind(this);
  }

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  componentDidMount() {
    $(".yesSelected").click(function () {
      $(".hiddenPart").show();
    });
    $(".noSelected").click(function () {
      $(".hiddenPart").hide();
    });
  }

  proceedEvent(event) {
    window.location.href = "/theatre/post/op/observations/care2";
  }

  handleChange(event) {
    this.setState({ [event.target.name]: event.target.value });
  }

  onTableChange(event) {}

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      "Access-Control-Allow-Origin": "*",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("visitId"),
      surgeryid: localStorage.getItem("surgeryid"),
    };

  

    event.preventDefault();
    console.log(localStorage.getItem("objectLength"));
    var objectLength = localStorage.getItem("objectLength");

    this.setState({
      Year: this.state.tablevaluesglobal[0]["Year"],
      loading: true
    });

    console.log(this.state.tablevaluesglobal);

    for (var i = 0; i < Object.keys(this.state.tablevaluesglobal).length; i++) {
      // console.log(this.state.tablevaluesglobal[i]['Year'])

      var dict = {
        ObservationsCare1Time:
          this.state.tablevaluesglobal[i]["ObservationsCare1Time"],
        Airway: this.state.tablevaluesglobal[i]["Airway"],
        oxygen: this.state.tablevaluesglobal[i]["oxygen"],
        Resp: this.state.tablevaluesglobal[i]["Resp"],
        Pulse: this.state.tablevaluesglobal[i]["Pulse"],
        Temp: this.state.tablevaluesglobal[i]["Temp"],
        BP: this.state.tablevaluesglobal[i]["BP"],
        SPO2: this.state.tablevaluesglobal[i]["SPO2"],
        LOC: this.state.tablevaluesglobal[i]["LOC"],
        Headlift: this.state.tablevaluesglobal[i]["Headlift"],
        LimbObs: this.state.tablevaluesglobal[i]["LimbObs"],
        Datetime: this.state.tablevaluesglobal[i]["Datetime"],
      };

      axios
        .post(
          this.api_url+"optheatre/operativeorders/post/labour/observationscare1",
          dict,
          { headers: headers }
        )
        .then((response) => {
          console.log(response);
          // /triage/antenatal/history
          this.setState({
            loading:false
          })
          if (response.data) {
            console.log(headers);
            axios
              .get(
                this.api_url+"/optheatre/operativeorders/post/labour/observationscare1",
                { headers: headers }
              )
              .then((response) => {
                console.log(response);
                let table = response.data;
                console.log(table);
                let object = {};
                for (let i = 0; i < table.length; i++) {
                  delete table[i]._id;
                  delete table[i].timeOfRegistration;
                  table[i].clickEvent = () => this.handleRowClick(table[i]);
                }
                // table = JSON.stringify(table);
                this.TableData = table;
                console.log(this.TableData);
                this.setState({
                  DataLoaded: true,
                });
              })
              .catch((error) => {
                console.log(error);
              });

            if (response.data["status"]) {
              $(".alert-success").show();
              setTimeout(function () {
                // alert('sdsd')
                $(".HistoryModal").show();
              }, 1500);
            }
          }
        })
        .catch((error) => {
          this.setState({
            loading:false
          })
          $(".alert-success").hide();
          $("#SubmitError").show();
          console.log(error);
        });
    }
  };

  handleTableChange(event) {
    // console.log(event);
    // this.setState({ myParentTrigger: this.state.myParentTrigger + 'a' });
  }

  formatTableOutput(data) {
    let topobj = {};
    let tableobj = {};
    for (let i = 0; i < data.length; i++) {
      let trim = data[i];
      let trimobj = {};
      this.setState({
        Year: "1212",
      });

      trimobj.ObservationsCare1Time = data[i][0];
      trimobj.Airway = data[i][1];
      trimobj.oxygen = data[i][2];
      trimobj.Resp = data[i][3];
      trimobj.Pulse = data[i][4];
      trimobj.Temp = data[i][5];
      trimobj.BP = data[i][6];
      trimobj.SPO2 = data[i][7];
      trimobj.LOC = data[i][8];
      trimobj.Headlift = data[i][9];
      trimobj.LimbObs = data[i][10];
      trimobj.Datetime = data[i][11];
      tableobj[i] = trimobj;
      topobj.prepplan = tableobj;
    }
    this.state.tablevaluesglobal = topobj["prepplan"];
  }

  getTableValues(event) {
    // console.log('entns');
    // console.log(event);
    let tablevalues = this.formatTableOutput(event);
    // console.log(tablevalues);
  }

  render() {
    //Editable table variables
    const data = [
      ["", "", "", "", "", "", "", "", "", "", "",""],

      // ["4th", "", ""],
    ];

    const columns = [
      "ObservationsCare1Time",
      "Airway",
      "oxygen",
      "Resp",
      "Pulse",
      "Temp",
      "BP",
      "SPO2",
      "LOC",
      "Headlift",
      "LimbObs",
      "Datetime"
    ];

    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left" };
    const displayHidden = { display: "none" };
    const width100 = { width: "100%" };
    const autoscroll = { overflowY: "auto" };
    // {""":{"date""12/12/2022", "result":"good"}, "2nd":{"date":12/12/2022"","result":"good"}}

    const {
      AttendedAntenatalCare,
      NumPreviousVisits,
      FaciltyPreviousVisits,
      AntiTetanusVaccination,
      NumPreviousVaccinations,
      LastVaccinationDate,
      AnteNatalHistoryPreviousObstetricUltrasound,
      AnteNatalHistoryNumPreviousUltrasound,
      AnteNatalHistoryTableTrimester,
      AnteNatalHistoryTableDate,
      PreviousFacilityVisitDate,
      AnteNatalHistoryTableResult,
      patientName,
    } = this.state;

    let { DataLoaded, loading } = this.state;
    const tabledata = {
      columns: [
        {
          label: "ObservationsCare1Time",
          field: "ObservationsCare1Time",
          sort: "asc",
          width: 50,
        },
        {
          label: "Airway",
          field: "Airway",
          sort: "asc",
          width: 50,
        },
        {
          label: "oxygen",
          field: "oxygen",
          sort: "asc",
          width: 50,
        },
        {
          label: "Resp",
          field: "Resp",
          sort: "asc",
          width: 50,
        },
        {
          label: "Pulse",
          field: "Pulse",
          sort: "asc",
          width: 50,
        },
        {
          label: "Temp",
          field: "Temp",
          sort: "asc",
          width: 50,
        },
        {
          label: "BP",
          field: "BP",
          sort: "asc",
          width: 50,
        },
        {
          label: "SPO2",
          field: "SPO2",
          sort: "asc",
          width: 50,
        },
        {
          label: "LOC",
          field: "LOC",
          sort: "asc",
          width: 50,
        },
        {
          label: "Headlift",
          field: "Headlift",
          sort: "asc",
          width: 50,
        },
        {
          label: "LimbObs",
          field: "LimbObs",
          sort: "asc",
          width: 50,
        },
      ],
      rows: this.TableData,
    };
    return (
      <div>
        <Headers />
        <TheatreSidebar />
        <main className="content-container ">
          <div className="container p-2">
            <form id="obsform" onSubmit={this.handleSubmit}>
              <MDBCard>
                <MDBCardHeader
                  tag="h3"
                  className="text-center font-weight-bold text-capitalise py-4"
                >
                  Post Operative Observations care 1
                </MDBCardHeader>
                <MDBCardBody>
                  <MDBTableEditable
                    onChange={(value) => this.handleTableChange(value)}
                    getValue={(value) => this.getTableValues(value)}
                    myParentTrigger={this.state.myParentTrigger}
                    id="editablecard"
                    data={data}
                    columns={columns}
                    striped
                    bordered
                  />
                </MDBCardBody>
              </MDBCard>

              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                className="alert alert-danger"
                id="SubmitError"
                style={displayHidden}
                role="alert"
              >
                <strong> </strong>Something went wrong. Please try again
              </div>
              <div
                id="SubmitSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>Details were saved Successfuly.
              </div>
              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    {loading ? 'Loading' : 'Submit'}
                  </button>
                </div>
              </div>
              {/* <div className="alert alert-danger contactAdmin" style={displayHidden} role="alert">
                            <strong>Wait! </strong>Contact Administrator to get account approval.
                        </div> */}
            </form>
            <div className="modal  HistoryModal" tabIndex="-1" role="dialog">
              <div className="modal-dialog" role="document">
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">
                      {" "}
                      {patientName}`s Post Operative Observation Modal
                    </h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    {/* <div className="py-1">
                        <h6 className="text-capitalize" style={ fontFamilyNunito }>Name</h6><input className="form-control"   type="text" required/>
                    </div> */}
                    <br />
                    <br />
                    <br />
                    <a
                      className="btn btn-danger proceed"
                      onClick={this.proceedEvent}
                      style={width100}
                    >
                      Proceed to Next
                    </a>
                    <Preview id={"jsx-template"}>
                      <b>NAME: </b>
                      {patientName}

                      <MDBDataTable striped bordered data={tabledata} />
                    </Preview>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    );
  }
}

export default PostOpObservationScare1;
